import React from "react";
import useUploadFiles from "../../../hooks/useUploadFiles";

// app components
import Upload from "../../../component/modals/upload";
import TextInput from "../../../component/element/forms/TextInput";
import SelectDate from "../../../component/element/forms/SelectDate";
// import SelectFile from "../../../component/element/forms/SelectFile";

// constants and icon
import { useParams } from "react-router-dom";
import {
  IUploadErrorDocument,
  IUploadDocument as IUploadNewDocument,
} from "../../../store/types/request";
import { useAppSelector } from "../../../store";
import Modal from "../../../component/ui/modal";

type IUploadDocument = {
  show: boolean;
  onCloseView: (data: IUploadNewDocument) => void;
};

export const UploadDocument: React.FC<IUploadDocument> = ({
  show,
  onCloseView,
}) => {
  const { id } = useParams();
  const loading = useAppSelector(({ request }) => request.loading);
  const { loader, uploadFile, deleteFiles } = useUploadFiles();
  const [data, dataSet] = React.useState<IUploadNewDocument>({
    name: "",
    issuing_body: "",
    issuing_date: "",
    expiring_date: "",
    path: "",
    request_id: "",
  });
  const [error, errorSet] = React.useState<IUploadErrorDocument>({
    request_id: "",
    name: "",
    issuing_body: "",
    issuing_date: "",
    expiring_date: "",
    path: "",
  });

  const onSubmit = async () => {
    let err = false;
    if (!data.name) {
      err = true;
      errorSet((prev) => ({ ...prev, name: "error: this field is required" }));
    }
    if (!data.expiring_date) {
      err = true;
      errorSet((prev) => ({
        ...prev,
        expiring_date: "error: this field is required",
      }));
    }
    if (!data.issuing_body) {
      err = true;
      errorSet((prev) => ({
        ...prev,
        issuing_body: "error: this field is required",
      }));
    }
    if (!data.issuing_date) {
      err = true;
      errorSet((prev) => ({
        ...prev,
        issuing_date: "error: this field is required",
      }));
    }
    if (!data.path) {
      err = true;
      errorSet((prev) => ({ ...prev, path: "error: this field is required" }));
    }

    if (err) return;
    onCloseView(data);
  };

  const onLoad = React.useCallback(() => {
    if (id) dataSet((prev) => ({ ...prev, request_id: id }));
  }, [id]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    dataSet((prev) => ({ ...prev, [name]: value }));
    errorSet((prev) => ({ ...prev, [name]: "" }));
  };

  const handleClose = () => {
    const newData = {
      request_id: "",
      name: "",
      issuing_body: "",
      issuing_date: "",
      expiring_date: "",
      path: "",
    };
    onCloseView(newData);
    dataSet(newData);
  };

  return (
    <Modal
      title="Upload Document"
      open={show}
      onClose={handleClose}
      onOkClick={onSubmit}
      isLoading={loading}
    >
      <div className="w-full space-y-6">
        <Upload
          title="Upload Document"
          name="documents"
          loading={loader}
          status={error.path}
          completed={data.path ? true : false}
          onChange={async (fileOrFiles) => {
            const paths = await uploadFile(fileOrFiles as File, "documents");
            if (paths.length > 0) {
              const file_path = paths[0]?.base_url + "/" + paths[0]?.path;
              dataSet((prev) => ({ ...prev, path: file_path }));
              errorSet((prev) => ({ ...prev, path: "" }));
            }
          }}
          onDelete={async () => {
            if (data.path) {
              const res = await deleteFiles(data.path);
              if (res) {
                dataSet((prev) => ({ ...prev, path: "" }));
                errorSet((prev) => ({ ...prev, path: "" }));
              }
            }
          }}
        />
        <TextInput
          type="text"
          label="Document Name"
          placeholder="Enter Document Name"
          name="name"
          status={error?.name}
          value={data.name}
          onChange={onChange}
        />
        <TextInput
          type="text"
          label="Issueing Body"
          placeholder="Enter Issuing Body"
          name="issuing_body"
          status={error?.issuing_body}
          value={data.issuing_body}
          onChange={onChange}
        />

        <SelectDate
          label="Issueing Date"
          placeholder="Enter Issueing Date"
          // status={error.issuing_date}
          // value={data.issuing_date}
          onChange={(date) => {
            dataSet((prev) => ({ ...prev, issuing_date: date }));
            errorSet((prev) => ({ ...prev, issuing_date: "" }));
          }}
        />

        <SelectDate
          label="Expire Date"
          placeholder="Enter Expire Date"
          // name="expiring_date"
          // value={data.expiring_date}
          onChange={(date) => {
            dataSet((prev) => ({ ...prev, expiring_date: date }));
            errorSet((prev) => ({ ...prev, expiring_date: "" }));
          }}
        />
      </div>
    </Modal>
  );
};
